import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { DELAY } from '../constants/GeneralConstants';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { useEffect, useRef, useState } from 'react';
import { COUNTDOWN } from '../constants/DeliveryConstants';
dayjs.extend(utc);
export const useCountdownTimer = (cutoff, message) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [countdownMessage, setCountdownMessage] = useState(message);
    const intervalRef = useRef(null);
    const setCountdownTimer = (deadlineHour, deadlineMinute) => {
        const setMessage = () => {
            const now = dayjs.utc();
            const deadline = now.set('hour', deadlineHour).set('minute', deadlineMinute).set('second', 0);
            let countdownReplacement = '';
            if (now.isAfter(deadline)) {
                intervalRef.current && clearInterval(intervalRef.current);
                countdownReplacement = `${t('pdp.size.deliverypromise.txt.minutes_seconds_left', {
                    minutes: '00',
                    seconds: '00',
                })}`;
            }
            else {
                const minutesLeft = deadline.diff(now, 'minute');
                const hoursLeft = Math.floor(minutesLeft / 60);
                const minutesLeftAfterHours = minutesLeft - hoursLeft * 60;
                const secondsLeft = deadline.diff(now, 'second');
                const secondsLeftAfterMinutes = secondsLeft - minutesLeft * 60;
                countdownReplacement =
                    minutesLeft < 60
                        ? `${t('pdp.size.deliverypromise.txt.minutes_seconds_left', {
                            minutes: String(minutesLeft).padStart(2, '0'),
                            seconds: String(secondsLeftAfterMinutes).padStart(2, '0'),
                        })}`
                        : `${t('pdp.size.deliverypromise.txt.hours_minutes_left', {
                            hours: String(hoursLeft).padStart(2, '0'),
                            minutes: String(minutesLeftAfterHours).padStart(2, '0'),
                        })}`;
            }
            setCountdownMessage(message.replace(COUNTDOWN, countdownReplacement));
        };
        setMessage();
        intervalRef.current = setInterval(() => {
            setMessage();
        }, DELAY.DELAY_1000);
    };
    useEffect(() => {
        var _a, _b;
        intervalRef.current && clearInterval(intervalRef.current);
        if (!cutoff || !(message === null || message === void 0 ? void 0 : message.includes(COUNTDOWN)))
            return;
        const deadlineHour = parseInt((_a = cutoff.split(':')) === null || _a === void 0 ? void 0 : _a[0], 10);
        const deadlineMinute = parseInt((_b = cutoff.split(':')) === null || _b === void 0 ? void 0 : _b[1], 10);
        setCountdownTimer(deadlineHour, deadlineMinute);
    }, [cutoff, message]);
    return { countdownMessage };
};
